import { render, staticRenderFns } from "./PreferredCurrencyModal.vue?vue&type=template&id=1176b9bb&scoped=true&"
import script from "./PreferredCurrencyModal.vue?vue&type=script&lang=js&"
export * from "./PreferredCurrencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1176b9bb",
  null
  
)

export default component.exports